import ResourceHeader from './ResourceHeader';
export default ResourceHeader;
